import { render, staticRenderFns } from "./SsoPage.vue?vue&type=template&id=4a9f1680&scoped=true"
import script from "./SsoPage.vue?vue&type=script&lang=js"
export * from "./SsoPage.vue?vue&type=script&lang=js"
import style0 from "./SsoPage.vue?vue&type=style&index=0&id=4a9f1680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f1680",
  null
  
)

export default component.exports